module.exports = __webpack_public_path__ + "static/media/grid_emergency.4f659e57.svg";